<template>
  <IvrLayout title="電話自動受付予約（IVR）設定" showBack :onHome="back" :loading="busy">
    <section class="config">
      <div class="config-list">
        <p :class="['config-use', { 'config-stop': !ivrList.active }]">
          電話自動受付予約（IVR）は現在{{ ivrList.active ? '利用' : '停止' }}中です
        </p>
        <div v-if="ivrList.phoneNumber" class="config-detail">
          <p class="config-label">IVR用電話番号</p>
          <p class="config-tel">{{ ivrList.phoneNumber }}</p>
          <p v-if="ivrList.forwardingNumber" class="config-transfer-tel">
            （登録番号：{{ ivrList.forwardingNumber }}）
          </p>
        </div>
      </div>
      <div class="config-toggle">
        <ToggleSwitch v-model="active" @change="onSwitch" onText="開始" offText="停止" />
      </div>
    </section>
    <section class="property">
      <PropertySection
        title="SMS表記店名"
        :data="ivrList.displayName || '未設定'"
        @click="isShowSmsNameModal = true"
        description="予約者への予約確認SMSに表示される店名を設定します。"
      />
    </section>
    <section class="property">
      <PropertySection
        title="予約受付期限"
        :data="deadlineText()"
        @click="isShowTimeLimitModal = true"
        description="予約を受付する期限を設定します。"
      />
    </section>
    <section class="property">
      <ul>
        <li>
          <p class="title">予約受付パターン</p>

          <a class="title" @click="$router.push({ name: 'IvrTime' })">
            <div class="wrapper">
              <ClockIcon class="icon" width="40" height="40" />
              予約受付パターン
              <p class="note">電話自動受付予約（IVR）の受付パターンを設定します</p>
            </div>
          </a>
        </li>
        <li>
          <p class="title">利用実績</p>

          <a class="title" @click="$router.push({ name: 'IvrDownload' })">
            <div class="wrapper">
              <DownloadIcon class="icon" width="40" height="40" />
              利用実績
              <p class="note">電話自動受付予約（IVR）の利用実績を確認できます</p>
            </div>
          </a>
        </li>
      </ul>
    </section>
    <!-- SMS表記店名Modal -->
    <SmsNameModal
      v-if="isShowSmsNameModal"
      :name="ivrList.displayName"
      @save="saveSmsName"
      @close="isShowSmsNameModal = false"
    />
    <!-- 予約受付期限Modal -->
    <TimeLimitModal
      v-if="isShowTimeLimitModal"
      :date="isInit ? null : ivrList.deadlineDate"
      :time="isInit ? null : ivrList.deadlineTime"
      @close="isShowTimeLimitModal = false"
      @save="saveTimeLimit"
    />
  </IvrLayout>
  <!-- </div> -->
</template>

<script>
import { mapState } from 'vuex'
// import { models } from '@/utils/vue'
import IvrLayout from '@/components/templates/IvrLayout'
import ToggleSwitch from '@/components/molecules/ToggleSwitch'
import PropertySection from '@/components/molecules/PropertySection'
import SmsNameModal from '@/components/molecules/SmsNameModal'
import TimeLimitModal from '@/components/molecules/TimeLimitModal'
import Dialog from '@/components/molecules/ModalDialog'
import ClockIcon from '@/components/icons/clock'
import DownloadIcon from '@/components/icons/download'

export default {
  name: 'Ivr',
  components: {
    IvrLayout,
    ToggleSwitch,
    PropertySection,
    SmsNameModal,
    TimeLimitModal,
    ClockIcon,
    DownloadIcon,
  },
  data() {
    return {
      STATIC_PATH,
      GNAVI_MAINTENANCE,
      isShowSmsNameModal: false,
      isShowTimeLimitModal: false,
      active: false,
    }
  },
  computed: {
    ...mapState({
      ivrList: state => state.ivr.list.ivrList,
      busy: state => state.ivr.list.busy,
    }),
    daysObj() {
      const defDayArr = ['当日', '前日']
      const addDayArr = [...Array(89).keys()].map(i => i + 2 + '日前')
      return { ...[...defDayArr, ...addDayArr] }
    },
    isInit() {
      return !this.ivrList.deadlineDate && !this.ivrList.deadlineTime
    },
  },
  async created() {
    this.active = this.ivrList.active
  },
  methods: {
    async fetch(readonly) {
      await this.$store.dispatch('ivr/list/get', { readonly })
    },
    async onSwitch() {
      if (
        await Dialog.confirm({
          title: `電話自動受付予約（IVR）を${this.active ? '開始' : '停止'}`,
          message: `電話自動受付予約（IVR）を${this.active ? '開始' : '停止'}しますか？`,
          okText: `${this.active ? '開始' : '停止'}`,
          cancelText: '戻る',
        })
      ) {
        await this.$store.dispatch('ivr/edit/updateStauts', { active: this.active })
        this.fetch(false)
      } else {
        this.active = this.ivrList.active
      }
    },
    async saveSmsName(displayName) {
      if (!(await this.$store.dispatch('ivr/edit/saveSmsName', { displayName }))) return
      this.isShowSmsNameModal = false
      this.fetch(false)
    },
    async saveTimeLimit(date, time) {
      if (!(await this.$store.dispatch('ivr/edit/saveTimeLimit', { deadlines: { date, time } }))) return
      this.isShowTimeLimitModal = false
      this.fetch(false)
    },
    deadlineText() {
      const text = this.ivrList.deadlineTime
        ? `来店日${this.daysObj[this.ivrList.deadlineDate]}の${this.ivrList.deadlineTime}時まで`
        : '未設定'
      return text
    },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="postcss" scoped>
>>> main {
  padding: 32px;
}

.config {
  align-items: center;
  background-color: var(--white);
  box-sizing: border-box;
  display: grid;
  grid-gap: 30px;
  grid-template-columns: 1fr 1fr;
  width: 100%;

  &-list {
    padding: 20px;
  }

  &-use {
    font-size: 21px;
    font-weight: bold;
  }

  &-stop {
    color: var(--pure-red);
  }

  &-detail {
    align-items: center;
    display: flex;
    padding-top: 8px;
  }

  &-label {
    border: 1px solid var(--light-gray);
    font-size: 13px;
    margin-right: 8px;
    padding: 2px 8px;
  }
  &-tel {
    font-size: 18px;
    font-weight: bold;
    margin-right: 8px;
  }

  &-transfer-tel {
    font-size: 11px;
  }

  &-toggle {
    justify-self: end;
    padding: 8px 16px 0 0;
  }
}

.toggles {
  align-items: center;
  display: grid;
  grid-gap: 24px;
  grid-template-columns: 1fr max-content;
}

.property {
  padding-top: 24px;
  &:last-child {
    padding-bottom: 24px;
  }
}

.title {
  color: var(--very-dark-gray);
  font-size: 15px;
  font-weight: bold;
}

>>> .text {
  font-weight: bold;
}

ul {
  display: grid;
  grid-gap: 24px;
  grid-template-columns: 1fr 1fr;

  > li {
    .wrapper {
      background-color: var(--white);
      margin-top: 10px;
      padding: 24px;
      position: relative;
      text-align: center;

      &::before {
        border-right: 2px solid var(--moderate-blue);
        border-top: 2px solid var(--moderate-blue);
        content: '';
        height: 7px;
        position: absolute;
        right: 24px;
        top: 66px;
        transform: rotate(45deg);
        width: 7px;
      }
    }

    .note {
      font-size: 11px;
      font-weight: normal;
      padding-top: 4px;
    }
  }
}

.icon {
  display: block;
  fill: var(--moderate-blue);
  margin: 0 auto 8px;
}
</style>
